import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Loader from "../Component/Loader";

const NonAuthLayout = (props) => {
  const { loading } = useContext(MyContext);

  if (loading) {
    return <Loader />;
  }

  return (
    <div
      className="theme-color-3 modal-open"
      style={{ minHeight: "100dvh", overflowX: "hidden", overflowY: "auto" }}
    >
      {/* <Header /> */}
      <div className={``}>
        <Outlet />
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default NonAuthLayout;
